module.exports = __webpack_public_path__ + "img/大模型数据学习ico.9dacc88b.png";